import store from '../store';
import Axios from 'axios';
import { Message } from 'element-ui';

// 设置默认请求头信息
Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
Axios.defaults.headers.delete['Content-Type'] = 'application/json;charset=UTF-8';
Axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';
// Axios.defaults.timeout = 5000;
Axios.defaults.withCredentials = true; // 让ajax携带cookie

// 接口白名单
let whiteUrl = ['/sso/', '/sysmanager/'];
function isWhiteUrl (url) {
    let state = false;
    for (let i = 0; i < whiteUrl.length; i++) {
        if (url.indexOf(whiteUrl[i]) !== -1) {
            state = true;
            break;
        }
    }
    return state;
}

// # 请求拦截器
Axios.interceptors.request.use(
    // 正常请求拦截
    (requestConfig) => {
        // sso登录，公服菜单相关直接返回
        if (isWhiteUrl(requestConfig.url)) {
            return requestConfig;
        }
        requestConfig.baseURL = '/api';
        return requestConfig;
    },
    // 错误请求拦截
    (error) => {
        return Promise.reject(error);
    }
);

// # 响应拦截器
Axios.interceptors.response.use(function (response) {
    // http接口请求异常
    if (response.status !== 200) {
        throw new Error(`接口【${response.config.url}】请求失败`);
    }
    // 文件流直接返回
    if (response.data instanceof Blob) {
        return response;
    }
    // 403表示token过期，需要重新登录(统一走这个，sso的也是)
    if (response.data.OpCode === 403) {
        Message({
            type: 'warning',
            message: '登录凭证过期，请重新登录'
        });
        setTimeout(() => {
            store.commit('account/logout');
        }, 1500);
        return response;
    }
    // sso登录，公服菜单相关直接返回
    if (isWhiteUrl(response.request.responseURL)) {
        return response;
    }
    // 后端服务异常
    if (Number(response.data.statusCode) !== 200) {
        Message({
            type: 'error',
            message: response.data.opDesc || '请求异常'
        });
        return Promise.reject(response.data);
    }
    // 操作失败之类
    if (Number(response.data.opCode) !== 0) {
        Message({
            type: 'error',
            message: response.data.opDesc || '操作失败'
        });
        return Promise.reject(response.data);
    }
    return response;
}, function (error) {
    if (error.code === 'ECONNABORTED') {
        console.error('请求超时');
    } else {
        console.error('请求失败');
    }
    Message({
        type: 'error',
        message: '请求失败'
    });
    return Promise.reject(error);
});
